import { NgModule } from '@angular/core';
import { BusinessSlugPipe } from './business-slug.pipe';

@NgModule({
  declarations: [BusinessSlugPipe],
  exports: [BusinessSlugPipe]
})
export class BusinessSlugModule {}
